import { render } from "./TestRecordView.vue?vue&type=template&id=153cb8c4&scoped=true"
import script from "./TestRecordView.vue?vue&type=script&lang=js"
export * from "./TestRecordView.vue?vue&type=script&lang=js"

import "./TestRecordView.vue?vue&type=style&index=0&id=153cb8c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153cb8c4"]])

export default __exports__